import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { CiSearch } from "react-icons/ci";
import { FilterList as FilterListIcon } from "@mui/icons-material";
import { ticketStatus } from "./action";

const TicketSearchAndFilter = ({
  searchText,
  setSearchText,
  selectedFilter,
  setSelectedFilter,
}) => {
  const { palette, ...theme } = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: { xs: "wrap", sm: "nowrap" },
        gap: "16px",
      }}
    >
      {/* Search */}
      <Box
        style={{
          display: "flex",
          width: "100%",
          border: "1px solid #D8D5CD",
          minWidth: "300px",
          height: "50px",
          background: "#000",
          borderRadius: "10px",
          alignItems: "center",
          justifyContent: "flex-start",
          [theme.breakpoints.down("xs")]: {
            borderRadius: "12px",
          },
        }}
      >
        <input
          className="textarea"
          maxLength={30}
          style={{
            border: "none",
            width: "90%",
            height: "46px",
            background: "#000",
            fontSize: "16px",
            marginLeft: "20px",
            color: "#D8D5CD",
          }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search"
        />
        <CiSearch style={{ marginRight: "8px" }} size="20px" color="#D8D5CD" />
      </Box>

      {/* Filter */}
      <Box sx={{ display: "flex", gap: 2 }}>
        <FormControl
          variant="outlined"
          size="small"
          sx={{
            minWidth: 275,
            "& .MuiInputLabel-root": { color: "#D8D5CD" }, // Label color
            "& .MuiOutlinedInput-root": {
              color: "white", // Text color inside the select
              "& fieldset": { borderColor: "#D8D5CD" }, // Border color
              "&:hover fieldset": { borderColor: "lightgray" }, // Hover effect
              "&.Mui-focused fieldset": { borderColor: "white" }, // Focus effect
            },
            "& .MuiSelect-icon": { color: "white" }, // Dropdown arrow color
            "& .MuiMenuItem-root": { color: "black" }, // Menu items text color
          }}
        >
          <InputLabel id="status-filter-label">Status</InputLabel>
          <Select
            labelId="status-filter-label"
            value={selectedFilter}
            onChange={(e) => setSelectedFilter(e.target.value)}
            label="Status"
            sx={{ height: "50px" }}
            startAdornment={
              <InputAdornment position="start">
                <FilterListIcon sx={{ color: "white" }} fontSize="small" />
              </InputAdornment>
            }
          >
            <MenuItem value="All">All</MenuItem>
            {ticketStatus.map((status) => (
              <MenuItem key={status.id} value={status.id}>
                {status.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default TicketSearchAndFilter;
